import { prop } from '@ipfabric/utils/fp/prop';
import { makeWrapWithButtonAsA } from 'components/Button/ButtonAsA';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import {
  type ShowSidePanelCommand,
  showSidePanel,
} from 'components/Graph/commands/showSidePanel';
import { LayoutIcon } from 'components/icons/LayoutIcon';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

interface Props {
  panelTabToLoadData: ShowSidePanelCommand;
}

export const GraphSidePanelNoData: FC<Props> = (props) => {
  const {
    canvasGraph: {
      graphSidePanel: { noData: noDataMsg },
    },
  } = useLocale();
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  const handleSelectDataClick = () => {
    ctxProps.dispatch(showSidePanel, props.panelTabToLoadData);
  };

  const linkSelectData = makeWrapWithButtonAsA(handleSelectDataClick, {
    className: 'graph-side-panel-no-data__button',
  });

  return (
    <div className='flex flex-1 flex-col items-center justify-center'>
      <div className='graph-side-panel-no-data__title'>
        {noDataMsg.noItemsTitle}
      </div>
      <div className='graph-side-panel-no-data__subtitle mb-lgu-10'>
        {noDataMsg.description({ linkSelectData })}
      </div>
      <LayoutIcon
        title={null}
        className='graph-side-panel-no-data__icon'
        width={64}
        height={64}
      />
    </div>
  );
};
